import {
  Badge,
  Button,
  Descriptions,
  Icons,
  Popconfirm,
  TextField,
} from '@pankod/refine-antd'
import React from 'react'
import dayjs from 'dayjs'
import clsx from 'clsx'

import {
  PROGRAM_LOCAL_STATE,
  PROGRAM_LOCAL_STATE_LABEL,
  PROGRAM_LOCAL_BADGE_COLOR,
  TLMSProgramLocal,
} from '../types'
import { getNextProgramLocalState } from '@resources/lms-management/program-lokal/utils'

const ProgramLocalDetail = ({
  data,
  onUpdateStatus,
  canUpdateStatus,
  isUpdatingStatus,
}: {
  data?: TLMSProgramLocal
  onUpdateStatus: () => void
  canUpdateStatus: boolean
  isUpdatingStatus: boolean
}) => {
  const nextState = getNextProgramLocalState(
    data?.status || PROGRAM_LOCAL_STATE.DRAFT,
  )
  return (
    <>
      <Descriptions
        bordered
        size="small"
        column={2}
        className="mb-6"
        labelStyle={{ fontWeight: 600 }}
      >
        <Descriptions.Item span={2} label="ID">
          {data?.id}
        </Descriptions.Item>
        <Descriptions.Item span={2} label="Nama">
          {data?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Periode">
          {data?.startDate && data?.endDate ? (
            <>
              {dayjs(data?.startDate).format('DD MMM YYYY')} &mdash;{' '}
              {dayjs(data?.endDate).format('DD MMM YYYY')}
            </>
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <div className="flex flex-col gap-1">
            <div className="flex gap-1 mb-1">
              <Badge
                status={
                  PROGRAM_LOCAL_BADGE_COLOR[
                    data?.status || PROGRAM_LOCAL_STATE.DRAFT
                  ]
                }
                className={clsx(
                  data?.status !== PROGRAM_LOCAL_STATE.DONE &&
                    'animate-[1s_pulse_infinite]',
                )}
              />
              <div className="mr-5 font-bold">
                {
                  PROGRAM_LOCAL_STATE_LABEL[
                    data?.status || PROGRAM_LOCAL_STATE.DRAFT
                  ]
                }
              </div>
            </div>
            <Popconfirm
              placement="topRight"
              onConfirm={onUpdateStatus}
              disabled={
                !canUpdateStatus ||
                isUpdatingStatus ||
                nextState === PROGRAM_LOCAL_STATE.DRAFT
              }
              title={
                <>
                  Apakah Anda yakin ingin mengubah status program lokal menjadi{' '}
                  <strong>{PROGRAM_LOCAL_STATE_LABEL[nextState]}</strong>?
                </>
              }
              okText="Lanjutkan"
              cancelText="Batal"
            >
              <Button
                size="small"
                icon={<Icons.DoubleRightOutlined />}
                disabled={
                  !canUpdateStatus ||
                  isUpdatingStatus ||
                  nextState === PROGRAM_LOCAL_STATE.DRAFT
                }
                loading={isUpdatingStatus}
                type="primary"
                className="!max-w-fit"
              >
                Ubah status
              </Button>
            </Popconfirm>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label="Provinsi" span={2}>
          {data?.provinsi ? (
            data?.provinsi
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Kota/Kabupaten">
          {data?.kotaKab ? (
            data?.kotaKab
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Kecamatan">
          {data?.kecamatan ? (
            data?.kecamatan
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
      </Descriptions>
    </>
  )
}

export default ProgramLocalDetail
